/* eslint-disable import/no-named-as-default-member */
/* eslint-disable import/prefer-default-export */
import { takeLatest, put, all } from 'redux-saga/effects' // eslint-disable-line
import editSocioEcoActions, {
    editSocioEcoTypes,
} from '../../../redux/collectData/editSocioEco'
import getSocioEcoDataActions from '../../../redux/donneesSocioEconomique/getSocioEcoData'
import { Put } from '../../../serveur/axios'
import alertActions from '../../../redux/alert'

function* editSocioEcoSagas({ response }) {
    try {
        const res = yield Put(`economic_data/${response.id}`, response)
        const { history } = response
        console.log(response)
        if (res.status === 200 || res.status === 201) {
            yield all([
                yield put(getSocioEcoDataActions.getSocioEcoDataRequest()),
                yield put(editSocioEcoActions.editSocioEcoSuccess(res.data)),
                yield put(
                    alertActions.alertShow(true, {
                        onConfirm: false,
                        warning: false,
                        info: false,
                        error: false,
                        success: true,
                        message: response.intl.formatMessage({
                            id: 'successSagaMessage',
                        }),
                        title: response.intl.formatMessage({
                            id: 'successSagaTitle',
                        }),
                    })
                ),
                history.push(
                    '/formulaires/gestion-des-données/socioéconomiques',
                    response.values,
                    console.log(response.values)
                ),
            ])
        } else {
            yield put(editSocioEcoActions.editSocioEcoFailure(res))
        }
    } catch (error) {
        yield put(editSocioEcoActions.editSocioEcoFailure(error))
    }
}

export function* editSocioEcoSaga() {
    yield takeLatest(
        editSocioEcoTypes.EDIT_SOCIO_ECO_REQUEST,
        editSocioEcoSagas
    )
}
